import Button from '@components/Button/Button';
import styles from './Services.module.css';

export default function Services() {
  return (
    <>
      {/* ---- Page header ---- */}
      <section className={styles.header}>
        <div className="container">
          <h1 className={styles.title}>Our Services</h1>
          <p className={styles.subtitle}>
            Comprehensive solutions tailored to your goals.
          </p>
        </div>
      </section>

      {/* ---- Services grid ---- */}
      <section className="section">
        <div className="container">
          <div className={styles.grid}>
            {SERVICES.map(({ title, description, icon }) => (
              <div key={title} className={styles.card}>
                <span className={styles.icon}>{icon}</span>
                <h3 className={styles.cardTitle}>{title}</h3>
                <p className={styles.cardText}>{description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ---- CTA ---- */}
      <section className={styles.cta}>
        <div className="container" style={{ textAlign: 'center' }}>
          <h2>Need a Custom Solution?</h2>
          <p className={styles.ctaText}>
            We&rsquo;d love to hear about your project. Reach out and
            let&rsquo;s explore what we can build together.
          </p>
          <Button to="/contact" variant="primary" size="lg">
            Start a Conversation
          </Button>
        </div>
      </section>
    </>
  );
}

const SERVICES = [
  {
    icon: '🌐',
    title: 'Web Development',
    description:
      'Responsive, performant websites and web applications built with modern frameworks.',
  },
  {
    icon: '📱',
    title: 'Mobile Apps',
    description:
      'Native and cross-platform mobile experiences that delight users on every device.',
  },
  {
    icon: '🎨',
    title: 'UI / UX Design',
    description:
      'Research-driven design that balances aesthetics with usability and accessibility.',
  },
  {
    icon: '📈',
    title: 'Digital Strategy',
    description:
      'Data-informed marketing and growth plans that turn visitors into loyal customers.',
  },
  {
    icon: '☁️',
    title: 'Cloud & DevOps',
    description:
      'Scalable infrastructure, CI/CD pipelines, and cloud architecture for reliable delivery.',
  },
  {
    icon: '🔒',
    title: 'Consulting',
    description:
      'Expert guidance on technology decisions, architecture reviews, and digital transformation.',
  },
];
